<div class="cell auto grid-y align-center align-middle">
    <i class="cell shrink devicePreview-osIcon " [ngClass]="getOsIcon(device.os)"></i>
</div>
